module.exports = __webpack_public_path__ + "static/media/operaciones.5edb3fda.svg";